export default __webpack_public_path__ + "static/media/screenBlock8.09add241.jpg";